<template>
  <div class="orders">
        <!--
        <b-form inline v-if="show">
          <label class="sr-only" for="inline-form-custom-select-pref">Etapa da transação</label>
          <b-form-select
            id="inline-form-custom-select-pref"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Etapa de transação', value: null }, 'Etapa 1', 'Etapa 2', 'Etapa 3']"
            :value="null"
          ></b-form-select>

          <b-button type="submit" variant="success">Mostrar aprovados</b-button>
        </b-form>
        -->

        <table class="table mt-2">
          <tbody v-for="tx in txs.list" v-bind:key="tx.id">
            <tr>
              <td>
                <router-link
                  class="font-weight-bold"
                  :to="{
                    name: 'CustomerServiceDetailsNew',
                    params: { txid: tx.uuid }
                  }"
                  >#{{ tx.id | numeral("00000") }}
                  </router-link>
                <p>
                  {{ tx.dateCreated | moment }}
                  {{ tx.dateCreated | moment-hour }}
                </p>
              </td>
              <td>
                <b-media>

                  <template #aside>
                    <img
                      v-if="tx.profilePicture"
                      :src="tx.profilePicture"
                      class="img-avatar img-profile"
                      style="height: 50px;"
                    />
                    <img v-else src="https://via.placeholder.com/150" alt=""
                    class="img-avatar img-profile" style="height: 50px">
                  </template>

                  <p class="font-weight-bold">{{ tx.buyerName }}</p>
                  <p>{{ tx.amount | numeral("$ 0,0.00") }}</p>

                </b-media>
              </td>
              <td>
                <p>{{ tx.buyerEmail }}</p>
                <p>{{ tx.buyerPhone }}</p>
              </td>
              <td>
                <b-media>

                  <template #aside>
                    <img
                      style="height: 50px"
                      :src="
                        '/static/sellers/' +
                          tx.sellerName[0].toUpperCase() +
                          tx.sellerName
                            .toLowerCase()
                            .replace(/ /g, '_')
                            .slice(1) +
                          '.png'
                      "
                    />
                   <!-- <img src="https://via.placeholder.com/150" alt="" style="height: 50px"> -->
                  </template>

                  <p class="font-weight-bold">{{ tx.sellerName }}</p>
                  <p>{{ tx.reference }}</p>

                </b-media>
              </td>
              <td>
                <p :class="tx.currentStep === 'Abandonado' ? 'text-secondary font-weight-bold' :
                   tx.currentStep === 'Esperando Aprovação' ? 'text-success font-weight-bold' :
                   tx.currentStep === 'Em Análise' ? 'text-success font-weight-bold' :
                   tx.currentStep === 'Criado' ? 'text-success font-weight-bold' :
                   tx.currentStep === 'Aprovado - Pagamentos Pendentes' ? 'text-success font-weight-bold' :
                   tx.currentStep === 'Iniciado' ? 'text-success font-weight-bold' :
                   tx.currentStep === 'Rejeitado' ? 'text-danger font-weight-bold' :
                   ''">{{ tx.currentStep }}</p>
              </td>
            </tr>
          </tbody>
        </table>

        <b-pagination
          size="md"
          align="center"
          :total-rows="total"
          v-model="currentPage"
          :per-page="max"
          @change="fetchData"
          limit="10"
        >
        </b-pagination>

  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: ['label', 'classes', 'to', 'icon', 'nolink', 'name', 'cpf'],
  data () {
    return {
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0,
      form: {
      },
      show: true
    }
  },
  mounted () {
  },
  created () {
    this.fetchData(1)
  },
  methods: {
    fetchData: function (val) {
      moment.locale('pt-br')
      var page = val || this.currentPage
      this.$http
        .get('api/customerservice/orders', {
          params: {
            offset: this.max * (page - 1),
            max: this.max,
            cpf: this.cpf
          }
        })
        .then(function (res) {
          console.log(res)
          this.txs = res.data
          this.total = res.data.total
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  watch: {
    '$route.params.txid' () {
      this.fetchData(1)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partial/order/Orders.vue